module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAAoUlEQVQ4jc3TsQkCQRQE0KcYGlqAYGoJFmBiZgdWYAd2YAViZuqFhobmxgY2IGJyZiuHi4ignN4KN7Awf1iGv/P/CiGUObNwR/bpblNC1Nes9UbvoI8rdlXNBljjiG5Zs788s41x5KuqZkVGy8izqmbfYoReHM5jQL9mNsEcw2ex/kt7wjTyHPtYX6K2wRmHWC+wfV3oRvHbU3aWzC1dZrgB0b1R5depXy8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/sjtj.png
// module id = OW7r
// module chunks = 1